import { Box } from 'grid'
import {
  Dialog,
  DialogType,
  IDialogProps,
  List,
  PrimaryButton,
  Stack,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'

export type ErrorsDialogProps = Omit<IDialogProps, 'modalProps'> & {
  errorList: string[]
  minWidth?: number
}

export const ErrorsDialog: React.FunctionComponent<ErrorsDialogProps> = ({
  dialogContentProps,
  errorList,
  minWidth,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const onRenderCell = (item: string | undefined): React.ReactNode => {
    return (
      <>
        <div style={{ whiteSpace: 'pre-line' }}>{item || ''}</div>
        <br />
      </>
    )
  }
  return (
    <Dialog
      minWidth={minWidth}
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Bitte beheben Sie die folgenden Fehler bevor Sie fortfahren',
        ...dialogContentProps,
      }}
      {...props}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 450 } },
      }}
    >
      <List items={errorList} onRenderCell={onRenderCell} />
      <Box mt={2}>
        <Stack
          tokens={{ childrenGap: theme.space![1] }}
          horizontal={true}
          horizontalAlign="end"
        >
          <Stack.Item>
            <PrimaryButton onClick={props.onDismiss as any}>
              {t('action.ok')}
            </PrimaryButton>
          </Stack.Item>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default ErrorsDialog
